import { Component, Input, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { Observable } from 'rxjs';

interface LoadingTemplateContext {
  $implicit: boolean;
}

@Component({
  selector: 'app-loading-content',
  standalone: true,
  imports: [CommonModule, NzSpinModule],
  template: `
    <ng-template #loadingTemplate>
      <ng-container *ngIf="isLoading$ | async; else noDataTpl">
        <div class="ant-select-loading-content">
          <nz-spin nzSimple></nz-spin>
        </div>
      </ng-container>
      <ng-template #noDataTpl>
        {{ noDataText }}
      </ng-template>
    </ng-template>
  `,
  styles: [
    `
      .ant-select-loading-content {
        padding: 8px;
        text-align: center;
      }
    `,
  ],
})
export class LoadingContentComponent {
  @Input() isLoading$!: Observable<boolean>;
  @Input() noDataText = 'No data found';
  @ViewChild('loadingTemplate')
  loadingTemplate!: TemplateRef<LoadingTemplateContext>;
}
